import { Injectable } from '@angular/core';
import axios, { AxiosRequestHeaders } from 'axios'; // Import Axios

@Injectable({
  providedIn: 'root',
})
export class IpService {
  private apiUrl = 'https://api.ipify.org?format=json'; // IP fetching service

  constructor() {}

  static async addHeaders(headers: AxiosRequestHeaders) {
    console.log('Adding headers');
    await new IpService().getIpAddress().then((ipData) => {
      const userIp = ipData?.ip || '0.0.0.0';
      headers['X-User-Ip'] = userIp;
      headers['X-User-Agent'] = navigator.userAgent;
      //ngrok-skip-browser-warning
      headers['ngrok-skip-browser-warning'] = '69420';
    });
    return headers;
  }

  // Get IP address using Axios internally
  async getIpAddress(): Promise<any> {
    const cachedIp = localStorage.getItem('userIp');
    if (cachedIp) {
      return { ip: cachedIp }; // Return cached IP if available
    } else {
      try {
        const response = await axios.get(this.apiUrl);
        const ip = response.data.ip;
        localStorage.setItem('userIp', ip); // Cache the IP address
        return { ip };
      } catch (error) {
        console.error('Error fetching IP address:', error);
        return { ip: '0.0.0.0' }; // Fallback IP
      }
    }
  }
}
